import React from 'react';
import './SocialLink.scss';

const SocialLink = (props) => {
  const {
    socialLink,
  } = props;
  const {
    type,
    link,
  } = socialLink;
  const { url } = link;
  const typeClass = type.replace(/\s+/g, '-').toLowerCase();
  return (
    <a
      className={`social-link ${typeClass}`}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open a new tab to ${type}`}
    >
      <span>{type}</span>
    </a>
  );
};

export default SocialLink;
